import type { Effort } from "@/shared/types/agents";

/** How hard a model thinks, as a person picks it: an agent's default in Settings, a
    message's in the composer. None picked: the model's own default, so nothing is sent. */
export const EFFORTS: { id: Effort; label: string; detail: string }[] = [
  { id: "low", label: "Low", detail: "Soonest" },
  { id: "medium", label: "Medium", detail: "Balanced" },
  { id: "high", label: "High", detail: "Most careful" },
];
export const MODEL_DEFAULT = "default";
